import ManagementAPI from "../../api/Management";
import { managementTypes } from "../types/management.types";
import BasicNotification from "../../shared/components/Notifications/BasicNotification";

export const getManagementTypes = (role, cb) => async (dispatch) => {
  dispatch({ type: managementTypes.GET_MANAGEMENT_TYPES });
  try {
    const { body } = await ManagementAPI.getManagementTypes(role);
    if (cb) {
      cb(body);
    }
    dispatch({ type: managementTypes.GET_MANAGEMENT_TYPES_SUCCESS, payload: { body } });
  } catch (error) {
    dispatch({ type: managementTypes.GET_MANAGEMENT_TYPES_FAILED, payload: { error } });
    error && BasicNotification.error('Ocurrió un error al obtener tipos de gestiones');
  }
};

export const getRefinancingManagementTypes = (cb) => async (dispatch) => {
  dispatch({ type: managementTypes.GET_CASE_MANAGEMENT_TYPES });
  try {
    const { body } = await ManagementAPI.getRefinancingManagementTypes();
    if (cb) cb(body);
    dispatch({ type: managementTypes.GET_CASE_MANAGEMENT_TYPES_SUCCESS, payload: { body } });
  } catch (error) {
    if (cb) cb(error.status);
    dispatch({ type: managementTypes.GET_CASE_MANAGEMENT_TYPES_FAILED, payload: { error } });
    error && BasicNotification.error('Ocurrió un error al obtener tipos de gestiones');
  }
};

export const getAllManagements = (id, cb) => async (dispatch) => {
  dispatch({ type: managementTypes.GET_ALL_MANAGEMENTS });
  try {
    const { body } = await ManagementAPI.getAllManagements(id);
    if (cb) {
      cb(body);
    }
    dispatch({ type: managementTypes.GET_ALL_MANAGEMENTS_SUCCESS, payload: { body } });
  } catch (error) {
    dispatch({ type: managementTypes.GET_ALL_MANAGEMENTS_FAILED, payload: { error } });
    error && BasicNotification.error('Ocurrió un error al obtener las gestiones');
  }
};

export const getCaseManagements = (id, cb) => async (dispatch) => {
  dispatch({ type: managementTypes.GET_CASE_MANAGEMENTS });
  try {
    const { body } = await ManagementAPI.getCaseManagements(id);
    if (cb) cb(body)
    dispatch({ type: managementTypes.GET_CASE_MANAGEMENTS_SUCCESS, payload: { body } });
  } catch (error) {
    if (cb) cb(error.status);
    dispatch({ type: managementTypes.GET_CASE_MANAGEMENTS_FAILED, payload: { error } });
    error && BasicNotification.error('Ocurrió un error al obtener las gestiones');
  }
};

export const getManagementById = (id, cb) => async (dispatch) => {
  dispatch({ type: managementTypes.GET_MANAGEMENT_REQUEST });
  try {
    const { body } = await ManagementAPI.getManagementById(id);
    if (cb) {
      cb(body);
    }
    dispatch({ type: managementTypes.GET_MANAGEMENT_SUCCESS, payload: { body } });
  } catch (error) {
    dispatch({ type: managementTypes.GET_MANAGEMENT_FAILED, payload: { error } });
    error && BasicNotification.error('Ocurrió un error al obtener la gestión');
  }
};

export const createManagement = (data, cb) => async (dispatch) => {
  dispatch({ type: managementTypes.POST_MANAGEMENT_REQUEST });
  try {
    const { body, status } = await ManagementAPI.createManagement(data);
    status === 200 && BasicNotification.success('Gestión creada exitosamente');
    if (cb) {
      cb(status, body);
    }
    dispatch({ type: managementTypes.POST_MANAGEMENT_SUCCESS, payload: { body } });
  } catch (error) {
    dispatch({ type: managementTypes.POST_MANAGEMENT_FAILED, payload: { error } });
    error && BasicNotification.error('Ocurrió un error al crear las gestiones');
  }
};

export const createCaseManagement = (data, cb) => async (dispatch) => {
  dispatch({ type: managementTypes.POST_CASE_MANAGEMENT_REQUEST });
  try {
    const { body, status } = await ManagementAPI.createCaseManagement(data);
    status === 200 && BasicNotification.success('Gestión creada exitosamente');
    if (cb) cb({ status, body });
    dispatch({ type: managementTypes.POST_CASE_MANAGEMENT_SUCCESS, payload: { body } });
  } catch (error) {
    if (cb) cb({ status: error.status, body: null });
    dispatch({ type: managementTypes.POST_CASE_MANAGEMENT_FAILED, payload: { error } });
    error && BasicNotification.error('Ocurrió un error al crear las gestiones');
  }
};

export const getContactTypes = (id, role, cb) => async (dispatch) => {
  dispatch({ type: managementTypes.GET_CONTACT_TYPES });
  try {
    const { body } = await ManagementAPI.getContactTypes(id, role);
    if (cb) {
      cb(body);
    }
    dispatch({ type: managementTypes.GET_CONTACT_TYPES_SUCCESS, payload: { body } });
  } catch (error) {
    dispatch({ type: managementTypes.GET_CONTACT_TYPES_FAILED, payload: { error } });
    error && BasicNotification.error('Ocurrió un error al obtener tipos de contactos');
  }
};

export const getTracking = (id, role, cb) => async (dispatch) => {
  dispatch({ type: managementTypes.GET_TRACKING_REQUEST });
  try {
    const { body } = await ManagementAPI.getTracking(id, role);
    if (cb) {
      cb(body);
    }
    dispatch({ type: managementTypes.GET_TRACKING_SUCCESS, payload: { body } });
  } catch (error) {
    dispatch({ type: managementTypes.GET_TRACKING_FAILED, payload: { error } });
    error && BasicNotification.error('Ocurrió un error al obtener estados de seguimientos');
  }
};

export const getSearchState = (managementType, cb) => async (dispatch) => {
  dispatch({ type: managementTypes.GET_SEARCH_STATE_REQUEST });
  try {
    const { body } = await ManagementAPI.getSearchState(managementType);
    if (cb) {
      cb(body);
    }
    dispatch({ type: managementTypes.GET_SEARCH_STATE_SUCCESS, payload: { body } });
  } catch (error) {
    dispatch({ type: managementTypes.GET_SEARCH_STATE_FAILED, payload: { error } });
    error && BasicNotification.error('Ocurrió un error al obtener los estados de búsqueda');
  }
};

export const getCloseReasons = (searchState, cb) => async (dispatch) => {
  dispatch({ type: managementTypes.GET_CLOSE_REASON_REQUEST });
  try {
    const { body } = await ManagementAPI.getCloseReasons(searchState);
    if (cb) {
      cb(body);
    }
    dispatch({ type: managementTypes.GET_CLOSE_REASON_SUCCESS, payload: { body } });
  } catch (error) {
    dispatch({ type: managementTypes.GET_CLOSE_REASON_FAILED, payload: { error } });
    error && BasicNotification.error('Ocurrió un error al obtener motivos de cierre');
  }
};

export const getReasons = (cb) => async (dispatch) => {
  dispatch({ type: managementTypes.GET_REASON_REQUEST });
  try {
    const { body } = await ManagementAPI.getReasons();
    if (cb) {
      cb(body);
    }
    dispatch({ type: managementTypes.GET_REASON_SUCCESS, payload: { body } });
  } catch (error) {
    dispatch({ type: managementTypes.GET_REASON_FAILED, payload: { error } });
    error && BasicNotification.error('Ocurrió un error al obtener los motivos');
  }
};

export const resetManagements = () => async (dispatch) => {
  dispatch({ type: managementTypes.RESET_ALL_MANAGEMENTS });
};

export const resetCaseManagements = () => async (dispatch) => {
  dispatch({ type: managementTypes.RESET_CASE_MANAGEMENTS });
};
